/* unplugin-vue-components disabled */import { render } from "./mainhome_enworld.vue?vue&type=template&id=5648f384&scoped=true"
import script from "./mainhome_enworld.vue?vue&type=script&lang=js"
export * from "./mainhome_enworld.vue?vue&type=script&lang=js"

import "./mainhome_enworld.vue?vue&type=style&index=0&id=5648f384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5648f384"]])

export default __exports__